import script from "./SchedulerSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchedulerSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./SchedulerSidebar.vue?vue&type=style&index=0&id=81ef3236&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81ef3236"]])

export default __exports__